
import {urlConfig} from '@/api/urlConfig'
import {fetch, promptMessage, baseUrl } from '@/api/dataHandling'
import {chinamobile} from '@/api/validate'
import {getken} from '@/api/getToken'
import {diseaseCommon} from '@/api/diseaseCommon'
import axios from 'axios'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import Cell from 'vux/src/components/cell/index'
export default {
data () {
return {
toastShow: false,
toastTxt: '',
nameIcon: false,
phoneNoIcon: false,
nationalityIcon: false,
birthdayIcon: false,
causeIcon: false,
sourceIcon: false,
maritalStatusIcon: false,
seeTypeIcon: false,
educationDegreeIcon: false,
cardTypeIcon: false,
cardNoIcon: false,
divisionIdIcon: false,
addressIcon: false,
familyIcon: false,
shiTxtIcon: false,
shengIcon: false,
sourceread: true,
ZJread: true,
lookIf: false,
diseaseCommon,
submitDisable: false,
ganyanIf: false,
jieheIf: false,
jiwangbingshiIf: false,
xinxueguanjibingIf: false,
xingbingchuanbojbsIf: false,
miniaoxitongganranIf: false,
neifenmijibingIf: false,
xiyanIf: false,
zhongdajingshencijishiIf: false,
xiguanyongyaoIf: false,
yaowuguominshiIf: false,
chushenquexianIf: false,
yichuanbingshiIf: false,
buyunbuyuIf: false,
shengTxt: '',
shiTxt: '',
sex: '男',
basedata: {
name: '',
gender: '1',
addressType: '09',
nationality: '',
birthday: '',
phoneNo: '',
cause: '',
source: '',
maritalStatus: '',
divisionId: '',
address: '',
family: '2',
cardNo: '',
cardType: '',
seeType: '',
educationDegree: ''
},
objdata: {
zhusu: '',
xianbingshi: '',
bingliriqi: '',
ganyan: '无',
ganyanbeizhu: '',
jiwangbingshi: '',
jiehe: '无',
jiehebeizhu: '',
xinxueguanjibing: '无',
xinxueguanjibingbeizhu: '',
xingbingchuanbojbs: '无',
xingbingchuanbojbsbz: '',
miniaoxitongganran: '无',
miniaoxitongganranbz: '',
neifenmijibingbeizhu: '',
neifenmijibing: '无',
qita: '',
xiyan: '无',
xiyanzhishu: '',
xujiu: '无',
xidu: '无',
zhongdajingshencijishi: '无',
xiguanyongyao: '无',
xiguanyongyaobeizhu: '',
yaowuguominshi: '无',
yaowuguominshibeizhu: '',
chushenquexian: '无',
chushenquexianbeizhu: '',
jiankangguoqu: '良好',
jiankangxianzai: '良好',
jinqinjiehun: '否',
zaihun: '否',
yichuanbingshi: '无',
yichuanbingshibeizhu: '',
buyunbuyu: '无',
buyunbuyubeihzu: ''
},
nationOptions: [],
marriageOptions: [],
ZYOptions: [],
HZLYOptions: [],
JZTypeOptions: [],
ZJTypeOptions: [],
whcdOptions: [],
shengOptions: [],
jiankangoptions: [],
shiOptions: [],
divisionOptions: [],
familyOptions: [
{
key: '1',
value: '有'
},
{
key: '2',
value: '无'
}
],
genifoptions: ['无', '有'],
genyesoptions: ['否', '是'],
tradeData: [],
trade: '',
tradeName: '',
tradeId: '',
showPopup: false
}
},
directives: {
TransferDom
},
components: {
Popup, Cell, Checker, CheckerItem, Checklist, Toast, Icon, Grid, GridItem, GroupTitle, Flexbox, FlexboxItem, Datetime, XTextarea, XInput, XHeader, Radio, XButton, Group, PopupRadio
},
methods: {
iftrim () {
this.requiredMethod(
[this.basedata.name, 'nameIcon'],
[this.basedata.nationality, 'nationalityIcon'],
[this.basedata.cause, 'causeIcon'],
[this.basedata.birthday, 'birthdayIcon'],
[this.basedata.source, 'sourceIcon'],
[this.basedata.maritalStatus, 'maritalStatusIcon'],
[this.basedata.seeType, 'seeTypeIcon'],
[this.basedata.cardType, 'cardTypeIcon'],
[this.basedata.divisionId, 'divisionIdIcon'],
[this.basedata.address, 'addressIcon'],
[this.basedata.family, 'familyIcon'],
[this.shengTxt, 'shengIcon'],
[this.shiTxt, 'shiTxtIcon'],
[this.basedata.educationDegree, 'educationDegreeIcon']
)
this.$nextTick(function () {
this.telchange()
this.SFZvalidate()
})
}, // 判断是否为空
telchange () {
let patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi
this.$nextTick(function () {
this.basedata.phoneNo = this.basedata.phoneNo.trim().replace(patrn, '')
if (/^1[3456789]\d{9}$/.test(this.basedata.phoneNo)) {
this.phoneNoIcon = false
} else {
this.phoneNoIcon = true
if (!this.basedata.phoneNo) {
return false
}
this.IconClick('电话号码格式不正确，请核实！')
}
})
},
SFZvalidate () {
let patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi
if (this.basedata.cardType == '01' || this.basedata.cardType == '04') {
this.$nextTick(function () {
this.basedata.cardNo = this.basedata.cardNo.trim().replace(patrn, '')
if (!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.basedata.cardNo))) {
this.cardNoIcon = true
if (!this.basedata.cardNo) {
return false
}
promptMessage('提示', '证件号码不正确，请核实！')
} else {
this.cardNoIcon = false
}
})
}
}, // 验证身份证
getnationData () {
this.getData()
this.nationOptions = []
fetch('get', urlConfig.getNation).then(response => {
for (let i = 0; i < response.length; i++) {
this.nationOptions.push({key: response[i].smzDm, value: response[i].smzCmc})
}
}).catch(error => {

})// 获取民族
fetch('get', urlConfig.getmarriage).then(response => {
for (let i = 0; i < response.length; i++) {
this.marriageOptions.push({key: response[i].sHyzkDm, value: response[i].sHyzkCmc})
}
}).catch(error => {

})  // 获取婚姻
fetch('get', urlConfig.getZY).then(response => {
for (let i = 0; i < response.length; i++) {
this.ZYOptions.push({key: response[i].sgrsfDm, value: response[i].sgrsfCmc})
}
}).catch(error => {

})  // 获取职业
fetch('get', urlConfig.getHZLY).then(response => {
for (let i = 0; i < response.length; i++) {
this.HZLYOptions.push({key: response[i].sScqdDm, value: response[i].sScqdCmc})
}
}).catch(error => {

})  // 获取来源
fetch('get', urlConfig.getJZType).then(response => {
for (let i = 0; i < response.length; i++) {
this.JZTypeOptions.push({key: response[i].sCzlxDm, value: response[i].sCzlxCmc})
}
}).catch(error => {

})  // 获取就诊类型
fetch('get', urlConfig.getZJType).then(response => {
for (let i = 0; i < response.length; i++) {
this.ZJTypeOptions.push({key: response[i].sGtbshDm, value: response[i].sGtbshCmc})
}
}).catch(error => {

})  // 获取证件类型
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token')
axios.post(baseUrl + urlConfig.getwhcd).then(response => {
for (let i = 0; i < response.data.length; i++) {
this.whcdOptions.push({key: response.data[i].swhcdDm, value: response.data[i].swhcdCmc})
}
}).catch(error => {

})  // 获取文化程度
axios.get(baseUrl + urlConfig.getIVF + '/216').then(response => {
for (let i = 0; i < response.data.data.length; i++) {
this.jiankangoptions.push(response.data.data[i].sZdCmc)
}
}).catch(error => {

})  // 获取获取健康状态
this.addressChange(0, 'shengOptions')

this.getTags()
},
addressChange (id, option, txt) {
this[option] = []
if (id !== '') {
fetch('get', urlConfig.getsheng + id).then(response => {
for (let i = 0; i < response.length; i++) {
this[option].push({key: response[i].id, value: response[i].sXzqhCmc})
}
if (txt) {
if (txt == 'shiTxt') {
this.basedata.divisionId = ''
} else if (txt == 'shengTxt') {
this.basedata.divisionId = ''
this.shiTxt = ''
}
}
this.iftrim()
}).catch(error => {

})  // 获取 省
}
},
getData () {
this.$store.commit('updateLoadingStatus', {isLoading: true})
this.SubmitData = {}
fetch('get', urlConfig.perfectMessageManUrl + '/' + this.rssEmrTypeId + '/' + this.rssEmrVerId + '/' + this.sgrjbxxId).then(response => {
console.log(response, 5)
this.SubmitData.rssEmrTypeId = this.rssEmrTypeId
this.SubmitData.rssEmrVerId = this.rssEmrVerId
this.SubmitData.sgrjbxxId = this.sgrjbxxId
if (response.personInfo.birthday) {
response.personInfo.birthday = (response.personInfo.birthday).substring(0, (response.personInfo.birthday).lastIndexOf(' '))
}
for (let i in response.personInfo) {
if (response.personInfo[i] == null) {
response.personInfo[i] = ''
}
}
this.basedata = response.personInfo
this.basedata.addressType = '09'
if (!this.basedata.divisionId) {
this.shengTxt = 'SSM20180424001510000'
this.addressChange(this.shengTxt, 'shiOptions')
} else {
fetch('get', urlConfig.getFsheng + this.basedata.divisionId).then(response => {
this.shiTxt = response[0].cityId
this.shengTxt = response[0].provinceId
this.addressChange(this.shengTxt, 'shiOptions')
this.addressChange(this.shiTxt, 'divisionOptions')
}).catch(error => {

})
}
if (response.recordMan.id == undefined || response.recordMan.id == null) { // 新增
this.SubmitData.createUserId = this.sgrjbxxId
this.lookIf = true
this.sourceread = false
this.ZJread = false
} else { // 修改
this.SubmitData.lastUpdateUserId = response.lastUpdateUserId
this.SubmitData.id = response.id
for (let i in response.recordMan) {
if (response.recordMan[i] == null) {
response.recordMan[i] = ''
}
}
console.log(response.personInfo, 67)
this.objdata = response.recordMan
}
if (response.status == 1) {
this.lookIf = true
if (response.personInfo.source == '') {
this.sourceread = false
} else {
this.sourceread = true
}
if (response.personInfo.cardNo == '') {
this.ZJread = false
} else {
this.ZJread = true
}
} else {
this.lookIf = false
this.ZJread = true
this.sourceread = true
promptMessage('提示', '该条个人信息已通过医生审核，不能再自行修改了！')
}
this.$store.commit('updateLoadingStatus', {isLoading: false})
this.iftrim()
}).catch(error => {

})
},
sureClick () {
this.SubmitData.clBcXml = this.clBcXml.temp(this.objdata)
this.SubmitData.recordMan = this.objdata
this.SubmitData.personInfo = this.basedata
let baseIndex = 0
for (let i in this.basedata) {
if (this.basedata[i]) {
baseIndex++
} else {
this.toastShow = true
this.toastTxt = '还有选项未填写'
if (i == 'divisionId' || i == 'address') {
$('body ,html').scrollTop($('#adressID').position().top - 50)
return false
} else {
$('body ,html').scrollTop(0)
return false
}
}
}
console.log(baseIndex, this.basedata)
if (baseIndex == Object.keys(this.basedata).length && !this.cardNoIcon && !this.phoneNoIcon) {  // 提交
this.submitDisable = true
this.$store.commit('updateLoadingStatus', {isLoading: true})
fetch('post', urlConfig.perfectMessageManUrl, this.SubmitData).then(response => {
this.$store.commit('updateLoadingStatus', {isLoading: false})
this.saveTags()
promptMessage('提示', '提交成功!', function () {
window.location.reload()
})
}).catch(error => {
this.submitDisable = false
this.$store.commit('updateLoadingStatus', {isLoading: false})
})
} else {
promptMessage('提示', '您的基本信息还未全部填写，不能提交！')
this.iftrim()
}
console.log(this.SubmitData)
}, // 提交
radioChoose (obj, objBZ) {
if (this.objdata[obj] == '无' || this.objdata[obj].trim() == '' || this.objdata[obj] == '否') {
this[obj + 'If'] = false
this.objdata[objBZ] = ''
} else {
this[obj + 'If'] = true
}
}, // 是否显示备注
colse () {
WeixinJSBridge.call('closeWindow')
},
requiredMethod () {
for (let i = 0; i < arguments.length; i++) {
if (arguments[i][0].trim() == '') {
this[arguments[i][1]] = true
} else {
this[arguments[i][1]] = false
}
}
}, // 是否必填
IconClick (text) {
this.toastShow = true
this.toastTxt = text
},
saveTags () {
let tradeTemp = {}
tradeTemp.personInfoId = this.sgrjbxxId
tradeTemp.tagId = this.trade
tradeTemp.id = this.tradeId
tradeTemp.userId = this.sgrjbxxId
if (!tradeTemp.tagId) {
return
}

fetch('post', urlConfig.saveTag, tradeTemp).then(response => {
}).catch(error => {
console.log(error)
})
},
getTags () {

fetch('post', urlConfig.queryUsableTags, { tagTypeCate: '1', personInfoId: this.sgrjbxxId }).then(response => {
const {tagCates, personTags} = response
if (tagCates.length > 0) {
this.tradeData = tagCates[0].tags
}
if (personTags.length > 0) {
this.tradeName = personTags[0].tagName
this.trade = personTags[0].tagId
this.tradeId = personTags[0].id
}
}).catch(error => {
console.log(error)
})
}
},
mounted () {
let _this = this
this.rssEmrTypeId = this.$route.query.rssEmrTypeId
this.rssEmrVerId = this.$route.query.rssEmrVerId
this.sgrjbxxId = this.$route.query.sgrjbxxId
getken(this.getnationData)
String.prototype.temp = function (obj) {
return this.replace(/\$\w+\$/gi, function (matchs) {
var returns = obj[matchs.replace(/\$/g, '')]
return (returns + '') == 'undefined' ? '' : returns
})
}

this.$nextTick(function () {
$('.inputClick').on('click', function () {
if (_this.lookIf) {
$(this).find('input, .textarea').focus()
}
})
})
this.clBcXml = '<?xml version="1.0" encoding="utf-8"?>\n' +
'<?xml-stylesheet type="text/xsl" href="manHis.xsl"?>\n' +
'<!-- 男方病例一 -->\n' +
'<manHis>\n' +
'  <jichuxinxi>\n' +
'    <bingliriqi required="1" cn="病历日期">$bingliriqi$</bingliriqi>\n' +
'    <zhusu required="1" cn="主诉">$zhusu$</zhusu>\n' +
'    <xianbingshi required="1" cn="现病史">$xianbingshi$</xianbingshi>\n' +
'  </jichuxinxi>\n' +
'  <jiwangbingshi>\n' +
'    <ganyan required="1" cn="肝炎">$ganyan$</ganyan>\n' +
'        <ganyanbeizhu cn="肝炎备注">$ganyanbeizhu$</ganyanbeizhu>\n' +
'        <jiehe required="1" cn="结核">$jiehe$</jiehe>\n' +
'        <jiehebeizhu cn="结核备注">$jiehebeizhu$</jiehebeizhu>\n' +
'        <xinxueguanjibing required="1" cn="心血管疾病">$xinxueguanjibing$</xinxueguanjibing>\n' +
'        <xinxueguanjibingbeizhu cn="心血管疾病备注">$xinxueguanjibingbeizhu$</xinxueguanjibingbeizhu>\n' +
'        <xingbingchuanbojbs required="1" cn="性传播疾病史">$xingbingchuanbojbs$</xingbingchuanbojbs>\n' +
'        <xingbingchuanbojbsbz cn="性传播疾病史备注">$xingbingchuanbojbsbz$</xingbingchuanbojbsbz>\n' +
'        <miniaoxitongganran required="1" cn="泌尿系统感染">$miniaoxitongganran$</miniaoxitongganran>\n' +
'        <miniaoxitongganranbz cn="泌尿系统感染备注">$miniaoxitongganranbz$</miniaoxitongganranbz>\n' +
'        <neifenmijibing required="1" cn="内分泌疾病史">$neifenmijibing$</neifenmijibing>\n' +
'        <neifenmijibingbeizhu cn="内分泌疾病史备注">$neifenmijibingbeizhu$</neifenmijibingbeizhu>\n' +
'        <qita cn="其他">$qita$</qita>\n' +
'    </jiwangbingshi>\n' +
'    <gerenshi>\n' +
'        <xiyan required="1" cn="吸烟">$xiyan$</xiyan>\n' +
'        <xiyanzhishu cn="吸烟支数">$xiyanzhishu$</xiyanzhishu>\n' +
'        <xujiu required="1" cn="酗酒">$xujiu$</xujiu>\n' +
'        <xidu required="1" cn="吸毒">$xidu$</xidu>\n' +
'        <xiguanyongyao required="1" cn="习惯用药">$xiguanyongyao$</xiguanyongyao>\n' +
'        <xiguanyongyaobeizhu cn="习惯用药备注">$xiguanyongyaobeizhu$</xiguanyongyaobeizhu>\n' +
'        <yaowuguominshi required="1" cn="药物过敏史">$yaowuguominshi$</yaowuguominshi>\n' +
'        <yaowuguominshibeizhu cn="药物过敏史备注">$yaowuguominshibeizhu$</yaowuguominshibeizhu>\n' +
'        <zhongdajingshencijishi required="1" cn="重大精神刺激史">$zhongdajingshencijishi$\n' +
'        </zhongdajingshencijishi>\n' +
'        <jiankangguoqu required="1" cn="健康状况:过去">$jiankangguoqu$</jiankangguoqu>\n' +
'        <jiankangxianzai required="1" cn="现在">$jiankangxianzai$</jiankangxianzai>\n' +
'        <chushenquexian required="1" cn="出生缺陷">$chushenquexian$</chushenquexian>\n' +
'        <chushenquexianbeizhu cn="出生缺陷备注">$chushenquexianbeizhu$</chushenquexianbeizhu>\n' +
'    </gerenshi>\n' +
'    <hunyinshi>\n' +
'        <jinqinjiehun required="1" cn="近亲结婚">$jinqinjiehun$</jinqinjiehun>\n' +
'        <zaihun required="1" cn="再婚">$zaihun$</zaihun>\n' +
'    </hunyinshi>\n' +
'    <jiazushi>\n' +
'        <yichuanbingshi required="1" cn="遗传病史">$yichuanbingshi$</yichuanbingshi>\n' +
'        <yichuanbingshibeizhu cn="详述">$yichuanbingshibeizhu$</yichuanbingshibeizhu>\n' +
'        <buyunbuyu required="1" cn="不孕不育病史">$buyunbuyu$</buyunbuyu>\n' +
'        <buyunbuyubeihzu cn="详述">$buyunbuyubeihzu$</buyunbuyubeihzu>\n' +
'    </jiazushi>\n' +
'</manHis>'
},
watch: {
trade (val) {
if (this.tradeData) {
for (let i = 0; i < this.tradeData.length; i++) {
if (val === this.tradeData[i].id) {
this.tradeName = this.tradeData[i].tagName
break
}
}
}
}
}
}



// WEBPACK FOOTER //
// ./src/project/perfectMessageProject/perfectMessageMan.vue